"use client";

import { amplifyConfig } from "@medimo/core-auth";
import { Amplify } from "aws-amplify";
import type { PropsWithChildren } from "react";

Amplify.configure(amplifyConfig, {
  ssr: true,
});

export function AmplifyConfig({ children }: PropsWithChildren) {
  return children;
}
